import { render, staticRenderFns } from "./ColorBadge.vue?vue&type=template&id=6c8b8e88&scoped=true&"
import script from "./ColorBadge.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ColorBadge.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ColorBadge.vue?vue&type=style&index=0&id=6c8b8e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b8e88",
  null
  
)

export default component.exports